import { typedAPI, ErrorCode } from "@markit/common.api";
import { ClientPlatform } from "@markit/common.types";

const API_BASE = "https://us-central1-markit-d5e9b.cloudfunctions.net/api/";
// const API_BASE = "http://192.168.0.211:8000/"; // office
// const API_BASE = "http://192.168.1.166:8000/"; // jonathan's
// const API_BASE = "http://192.168.1.159:8000/"; // home
// const API_BASE = "http://192.168.0.108:8000/"; // home home
// const API_BASE = "http://192.168.16.142:8000/";
// const API_BASE = "http://192.168.1.20:8000/";

const errorFunction = (errorCode: number) => {
  console.error(errorCode);
  switch (errorCode) {
    case ErrorCode.NO_TICKETS_REMAINING:
      alert("There are no more tickets remaining for this event");
      return;
    case ErrorCode.ALREADY_GOING:
      alert("You are already going to this event");
      return;
    case ErrorCode.USED_ITEM_ID:
    case ErrorCode.INVALID_ITEM_ID:
      alert(
        "Your ticket, promoter ticket, or promo code has already been redeemed or is invalid"
      );
      return;
  }
  return ErrorCode[errorCode];
};

const headers = {
  mode: process.env.NODE_ENV === "development" ? "development" : "live",
  "x-client-platform": ClientPlatform.WEB,
};

typedAPI.initialize(API_BASE, errorFunction, headers);

export { API_BASE, typedAPI as API };
